import { i18n } from '/locales/i18n'
window.I18n = i18n

import { Turbo } from '@hotwired/turbo-rails'
Turbo.start()

import '/turbo_streams'
import '/config'
import '/controllers'

import userConsent from '/libs/user_consent'
userConsent.start()

import RemoveFieldWithError from '/libs/remove_field_with_error'
document.addEventListener('DOMContentLoaded', () => new RemoveFieldWithError().init())
